import { IAppState } from '../../redux';
import { EUnavailableReason } from '../../redux/reducers';

export const selectIsBlockedOfferPublishBySanctions = (state: IAppState): boolean =>
  Object.values(state.publishTerms.services).every(
    ({ unavailableReasonType: r }) => r === EUnavailableReason.deniedBySanctions,
  );
